"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Global = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _api = require("@react-google-maps/api");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _palette = require("../../../styles/palette");

var _mapStyle = _interopRequireDefault(require("./mapStyle"));

var _templateObject;

var Global = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .gmaps-wrapper {\n    width: 100%;\n    min-height: 200px;\n    @media(min-width: 1024px) {\n      margin-top: 40px;\n      min-height: 80vh;\n    }\n  }\n"])));
exports.Global = Global;
Global.displayName = 'Global';

var Map = function Map(_ref) {
  var center = _ref.center,
      polygon = _ref.polygon,
      marker = _ref.marker,
      zoom = _ref.zoom,
      mapContainerClassName = _ref.mapContainerClassName;
  return _react["default"].createElement("div", null, _react["default"].createElement(Global, null), _react["default"].createElement(_api.GoogleMap, {
    zoom: zoom || 18,
    center: center,
    options: {
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: 'none',
      styles: _mapStyle["default"]
    },
    setZoom: zoom || 10,
    mapContainerClassName: mapContainerClassName
  }, marker && _react["default"].createElement(_api.Marker, {
    position: center,
    key: "".concat(marker.lng, ":").concat(marker.lat),
    options: {
      icon: {
        url: 'https://bob.io/wp-content/uploads/pin.png',
        scaledSize: {
          width: 22,
          height: 30
        }
      }
    }
  }), polygon && polygon.map(function (item) {
    return _react["default"].createElement(_api.Polygon, {
      paths: item,
      options: {
        fillColor: _palette.palette.success,
        fillOpacity: 0.35,
        strokeColor: _palette.palette.success,
        strokeOpacity: 0.5,
        strokeWeight: 2
      }
    });
  })));
};

Map.propTypes = {
  center: _propTypes["default"].instanceOf(Object),
  polygon: _propTypes["default"].instanceOf(Array),
  marker: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  zoom: _propTypes["default"].number,
  mapContainerClassName: _propTypes["default"].string
};
Map.defaultProps = {
  center: {
    lat: 40.4167426,
    lng: -3.703002
  },
  polygon: null,
  marker: null,
  zoom: undefined,
  mapContainerClassName: 'gmaps-wrapper'
};
var _default = Map;
exports["default"] = _default;